export default "__VITE_ASSET__NXfAatsJ__"